export class AppError extends Error {
  constructor(message, { code = 'UNKNOWN', status = 0, details = null } = {}) {
    super(message);
    this.name = 'AppError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

export function userMessage(error) {
  if (error?.code === 'ABORTED') return 'Traitement annulé.';
  if (error?.status === 413) return 'Le document dépasse la limite autorisée.';
  if (error?.status === 429) return 'Trop de traitements simultanés. Réessayez dans un instant.';
  return error?.message || 'Le traitement OCR a échoué.';
}
